export const agentObj = {
  id: "Agents",
  headline: "Become an Agent.",
  buttonLabel: "See Full Pricing List",
  imgStart: false,
  img: require("../../Assets/Images/Agent-man.jpg").default,
  alt: "Man happy holding phone",
};
